import { createFileRoute } from '@tanstack/react-router';
import { CampaignForm } from '../../components/campaigns/CampaignForm.js';

export const Route = createFileRoute('/_authed/campaigns/new')({
  component: () => (
    <div>
      <h2 className="mb-4 text-xl font-semibold text-neutral-900">New campaign</h2>
      <CampaignForm existing={null} />
    </div>
  ),
});
